import { ParallaxDirection, ParallaxType } from '../../core/modules/Parallax/ParallaxController';
import { Theme, ThemeName, Weather } from './theme';

export const cityNightTheme: Theme = {
  id: ThemeName.CityNight,
  texture: 'theme-city-night',
  isNight: true,
  weather: Weather.Dry,
  parallaxLayers: [
    // {
    //   type: ParallaxType.Tile,
    //   x: 960,
    //   y: 137,
    //   width: 1920,
    //   height: 300,
    //   texture: 'theme-city-night',
    //   frame: 'tile-city-night.png',
    //   depth: 1,
    //   scrollX: 0,
    //   scrollY: 0,
    //   speedX: 1,
    //   speedY: 0,
    //   naturalDriftX: 0,
    //   naturalDriftY: 0
    // },
    {
      type: ParallaxType.Sprite,
      direction: ParallaxDirection.Horizontal,
      x: 0,
      y: 137,
      autoZoomOffset: false,
      zoomOffsetX: 1,
      zoomOffsetY: 1,
      texture: 'theme-city-night',
      images: [
        {
          frame: 'tile-city-night.png',
          // scale: 1.25,
          gapBefore: -2
        },
        {
          frame: 'tile-city-night.png',
          // scale: 1.25,
          gapBefore: -2
        },
        {
          frame: 'tile-city-night.png',
          // scale: 1.25,
          gapBefore: -2
        }
      ],
      depth: 1,
      scrollX: 0,
      scrollY: 0,
      speedX: 1,
      speedY: 0,
      naturalDriftX: 0,
      naturalDriftY: 0
    },
    // {
    //   type: ParallaxType.Tile,
    //   x: 960,
    //   y: 533,
    //   width: 1920,
    //   height: 493,
    //   texture: 'theme-city-night',
    //   frame: 'tile-road-night.png',
    //   depth: 1,
    //   scrollX: 0,
    //   scrollY: 0,
    //   speedX: 1,
    //   speedY: 0,
    //   naturalDriftX: 0,
    //   naturalDriftY: 0
    // },
    {
      type: ParallaxType.Sprite,
      direction: ParallaxDirection.Horizontal,
      x: 0,
      y: 533,
      zoomOffsetX: 1,
      zoomOffsetY: 1,
      texture: 'theme-city-night',
      images: [
        {
          frame: 'tile-road-night.png',
          // scale: 1.1,
          gapBefore: -2
        },
        {
          frame: 'tile-road-night.png',
          // scale: 1.1,
          gapBefore: -2
        },
        {
          frame: 'tile-road-night.png',
          // scale: 1.1,
          gapBefore: -2
        }
      ],
      depth: 2,
      scrollX: 0,
      scrollY: 0,
      speedX: 1,
      speedY: 0,
      naturalDriftX: 0,
      naturalDriftY: 0
    },
    // {
    //   type: ParallaxType.Tile,
    //   x: 960,
    //   y: 200,
    //   width: 1920,
    //   height: 265,
    //   texture: 'theme-city-night',
    //   frame: 'tile-bg-people-night.png',
    //   depth: 1,
    //   scrollX: 0,
    //   scrollY: 0,
    //   speedX: 1,
    //   speedY: 0,
    //   naturalDriftX: 0,
    //   naturalDriftY: 0
    // },
    {
      type: ParallaxType.Sprite,
      direction: ParallaxDirection.Horizontal,
      x: 0,
      y: 200,
      zoomOffsetX: 1,
      zoomOffsetY: 1,
      texture: 'theme-city-night',
      images: [
        {
          frame: 'tile-bg-people-night.png',
          // scale: 1.1,
          gapBefore: -2,
        },
        {
          frame: 'tile-bg-people-night.png',
          // scale: 1.1,
          gapBefore: -2
        },
        {
          frame: 'tile-bg-people-night.png',
          // scale: 1.1,
          gapBefore: -2
        }
      ],
      depth: 3,
      scrollX: 0,
      scrollY: 0,
      speedX: 1,
      speedY: 0,
      naturalDriftX: 0,
      naturalDriftY: 0
    }
  ],
  roadDetails: {
    laneCount: 4,
    lanes: {
      0: { laneY: 86 },
      1: { laneY: 90 },
      2: { laneY: 95 },
      3: { laneY: 100 }
    },
    laneHeight: 100,
    laneScale: 0.05,
    laneVehicleScale: 0.025,
    startPointX: 0,
    startPointY: -52.5,
    vehicleOffset: 10,
    obstacleOffset: -20,
    pavementY: 378,
    pavementHeight: 77
  }
};
